/* unplugin-vue-components disabled */import script from "./standards.vue?vue&type=script&lang=ts&setup=true"
export * from "./standards.vue?vue&type=script&lang=ts&setup=true"

import "./standards.vue?vue&type=style&index=0&id=87ec127c&scoped=true&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-87ec127c"]])

export default __exports__